import React from 'react';
import errorGirl from '../../assets/images/500-vector-girl-color.png';
import ErrorPage from './ErrorPage';

export default class Error500 extends React.Component {
  render() {
    return (
      <ErrorPage
        errorGirl={errorGirl}
        title="500"
        subTitle="Ooops... Something went wrong."
      />
    );
  }
}
